export default __webpack_public_path__ + "static/hero-7ed1dfd90d441229c4605b83b711c30a.webp";